var _circle, _ellipse, _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconEstimate = function SvgIconEstimate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 9,
    fill: "#E6E9F3"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.5,
    cy: 21.5,
    rx: 8.5,
    ry: 9.5,
    fill: "#E6E9F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7827 16.0303V21.0202C14.7827 23.0872 18.1334 24.7626 22.2676 24.7626C26.4017 24.7626 29.7524 23.0872 29.7524 21.0202V16.0303",
    stroke: "#0930CC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7827 21.02V26.0099C14.7827 28.077 18.1334 29.7524 22.2676 29.7524C26.4017 29.7524 29.7524 28.077 29.7524 26.0099V21.02",
    stroke: "#0930CC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2676 19.7729C26.4013 19.7729 29.7524 18.0974 29.7524 16.0305C29.7524 13.9636 26.4013 12.2881 22.2676 12.2881C18.1338 12.2881 14.7827 13.9636 14.7827 16.0305C14.7827 18.0974 18.1338 19.7729 22.2676 19.7729Z",
    stroke: "#0930CC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0403 7.29785V11.0403H7.29785",
    stroke: "#0930CC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0403 19.7728C6.21758 19.7728 2.30798 15.8632 2.30798 11.0404C2.30798 6.2177 6.21758 2.30811 11.0403 2.30811C14.9961 2.30811 18.3381 4.93903 19.4109 8.54674",
    stroke: "#0930CC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconEstimate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IconEstimate.c3bc6d75.svg";
export { ForwardRef as ReactComponent };